import React, { useEffect, useState } from 'react';
import './PWDModal.scss';

const PWDModal = ({ open, title, loading, error, onClose, onConfirm }) => {
  const [password, setPassword] = useState('');

  useEffect(() => {
    if (open) {
      setPassword('');
    }
  }, [open]);

  if (!open) return null;

  const handleSubmit = (e) => {
    e.preventDefault();
    onConfirm(password);
  };

  return (
    <div className="pwd-modal-overlay" onClick={onClose}>
      <div className="pwd-modal" onClick={(e) => e.stopPropagation()}>
        <div className="pwd-modal-head">
          <h3>비밀번호 확인</h3>
          <p>비공개 게시글입니다. 작성 시 입력한 비밀번호를 입력해주세요.</p>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="pwd-modal-body">
            <div className="pwd-guide-box">
              <span className="guide-title">PRIVATE POST</span>
              <p className="guide-text">{title || '비공개 게시글'}</p>
            </div>

            <div className="pwd-input-group">
              <label>비밀번호</label>
              <input
                type="password"
                placeholder="비밀번호 입력"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                autoFocus
              />
            </div>

            {error ? <div className="pwd-error">{error}</div> : null}
          </div>

          <div className="pwd-modal-foot">
            <button type="button" className="btn-cancel" onClick={onClose}>
              취소
            </button>
            <button type="submit" className="btn-confirm" disabled={loading}>
              {loading ? '확인 중...' : '확인'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PWDModal;
